'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EditorType = require('./components/EditorType.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EditorType).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/editor-type/index.js
// module id = 1039
// module chunks = 0